/**
 * JSON-LD structured data schemas for Voice Up.
 * Used by StructuredData component to inject into page head.
 */

// === MusicSchool (LocalBusiness) - site-wide === //
export const musicSchoolSchema = {
    "@context": "https://schema.org",
    "@type": "MusicSchool",
    name: "Voice Up",
    description:
        "Cours de chant à Genève, pose de voix et coach vocal pour amateur et professionnel, méthode Complete Vocal Technique.",
    url: "https://myvoiceup.ch",
    image: "https://myvoiceup.ch/website_og_image.png",
    address: {
        "@type": "PostalAddress",
        streetAddress: "8 chemin de la Gravière",
        addressLocality: "Les Acacias",
        addressRegion: "Genève",
        postalCode: "1227",
        addressCountry: "CH",
    },
    geo: {
        "@type": "GeoCoordinates",
        latitude: 46.196895021090576,
        longitude: 6.1305201153444475,
    },
    openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "19:00",
    },
    priceRange: "CHF 100-340",
    sameAs: [
        "https://www.youtube.com/channel/UCG5hqAKbF5OxzGVx0jgoPGA",
        "https://www.instagram.com/killing_volts/",
        "https://www.facebook.com/myvoiceup/",
    ],
};

// === Person - About page === //
export const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Tania Guillin",
    jobTitle: "Professeure de chant et coach vocal",
    worksFor: {
        "@type": "MusicSchool",
        name: "Voice Up",
        url: "https://myvoiceup.ch",
    },
    url: "https://myvoiceup.ch/tania",
    knowsAbout: ["Complete Vocal Technique", "Singing", "Vocal coaching"],
};

// === Course schemas - Pricing page === //
export const courseSchemas = [
    {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "Cours de chant hebdomadaire",
        description:
            "1h de cours de chant toutes les semaines. Niveau débutant, moyen et avancé. Cours présentiels ou en ligne.",
        provider: {
            "@type": "MusicSchool",
            name: "Voice Up",
            url: "https://myvoiceup.ch",
        },
        offers: {
            "@type": "Offer",
            price: "340",
            priceCurrency: "CHF",
            availability: "https://schema.org/InStock",
            url: "https://myvoiceup.ch/tarifs",
        },
    },
    {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "Cours de chant bimensuel",
        description:
            "1h de cours de chant toutes les deux semaines. Niveau moyen et avancé. Cours présentiels ou en ligne.",
        provider: {
            "@type": "MusicSchool",
            name: "Voice Up",
            url: "https://myvoiceup.ch",
        },
        offers: {
            "@type": "Offer",
            price: "190",
            priceCurrency: "CHF",
            availability: "https://schema.org/InStock",
            url: "https://myvoiceup.ch/tarifs",
        },
    },
    {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "Cours de chant à la carte",
        description:
            "Cours de chant à l'heure, 100% flexible. Tous niveaux. Cours présentiels ou en ligne.",
        provider: {
            "@type": "MusicSchool",
            name: "Voice Up",
            url: "https://myvoiceup.ch",
        },
        offers: {
            "@type": "Offer",
            price: "100",
            priceCurrency: "CHF",
            availability: "https://schema.org/InStock",
            url: "https://myvoiceup.ch/tarifs",
        },
    },
];

/**
 * Builds a FAQPage schema from the QuestionsAnswers data array.
 * @param {Array} questions - Array of {questionFR, answerFR} objects
 */
export const buildFAQSchema = (questions) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((q) => ({
        "@type": "Question",
        name: q.questionFR,
        acceptedAnswer: {
            "@type": "Answer",
            text: q.answerFR,
        },
    })),
});
